import { createContext } from 'react';
/**
 * React context for managing chat messages state and operations.
 * Provides access to current and cached messages, prompts, and submission payload.
 * @public
 */
export const ChatMessagesContext = createContext({});